"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.ActionCreators = exports.defaultState = void 0;
var axios_1 = __importDefault(require("axios"));
var UserSessionStore_1 = require("../Session/UserSessionStore");
var ClientContextActions_1 = require("./ClientContextActions");
exports.defaultState = {
    clients: [],
    clientsLoaded: false,
};
exports.ActionCreators = {
    GetClients: function (usermanagementBaseUrl) {
        return function (dispatch) {
            dispatch({ type: ClientContextActions_1.ActionTypes.GET_CLIENT_CONTEXT_CLIENTS_REQUESTED });
            return axios_1.default
                .get(usermanagementBaseUrl + '/clients')
                .then(function (res) {
                if (res.status === 200) {
                    return res.data;
                }
            })
                .then(function (body) {
                dispatch({ type: ClientContextActions_1.ActionTypes.GET_CLIENT_CONTEXT_CLIENTS_SUCCESS, payload: body });
            })
                .catch(function (ex) {
                dispatch({ type: ClientContextActions_1.ActionTypes.GET_CLIENT_CONTEXT_CLIENTS_FAILED, error: ex.message });
            });
        };
    },
    ChangeClientContext: function (client, identityServerUrl, returnUrl) {
        return function (dispatch) {
            dispatch({ type: ClientContextActions_1.ActionTypes.CHANGE_CLIENT_CONTEXT_REQUESTED });
            return axios_1.default
                .put(identityServerUrl + 'api/client/' + client.clientId)
                .then(function (res) {
                if (res.status === 200) {
                    return res.data;
                }
            })
                .then(function () {
                var _a;
                UserSessionStore_1.UserSessionStore.sendMessage('NotifyClientConfirmed', identityServerUrl);
                UserSessionStore_1.UserSessionStore.sendMessage('NotifyChangeClient|' + client.clientId + '|' + (returnUrl || '/'), identityServerUrl);
                dispatch({ type: ClientContextActions_1.ActionTypes.CHANGE_CLIENT_CONTEXT_SUCCESS });
                (_a = window.pendo) === null || _a === void 0 ? void 0 : _a.identify({
                    account: {
                        id: client.clientId,
                        full_client_name: client.name,
                        agentid: client.unit,
                    },
                });
            })
                .catch(function (ex) {
                dispatch({ type: ClientContextActions_1.ActionTypes.CHANGE_CLIENT_CONTEXT_FAILED, error: ex.message });
            });
        };
    },
};
var reducer = function (state, action) {
    if (state === void 0) { state = exports.defaultState; }
    switch (action.type) {
        case ClientContextActions_1.ActionTypes.GET_CLIENT_CONTEXT_CLIENTS_REQUESTED:
            return __assign(__assign({}, state), { clients: [], clientsLoaded: false });
        case ClientContextActions_1.ActionTypes.GET_CLIENT_CONTEXT_CLIENTS_FAILED:
            return __assign(__assign({}, state), { clients: [], clientsLoaded: true });
        case ClientContextActions_1.ActionTypes.GET_CLIENT_CONTEXT_CLIENTS_SUCCESS:
            return __assign(__assign({}, state), { clients: action.payload, clientsLoaded: true });
    }
    return state;
};
exports.reducer = reducer;
